'use client'

import { MediaImageStandard, Typography } from '../Contentful'
import { useState, useMemo } from 'react'
import { StarRating } from '../StarRating'
import BillsRatingModal from '../BillsRatingModal/BillsRatingModal'
import { AchieveLink } from '../AchieveLink'
import { Button } from '@achieve/ascend'
import { ChevronDown, ChevronUp } from 'react-feather'
import ProviderReview from '../ProviderReview/ProviderReview'
import { withUuid } from 'utils/shared'

function ProductProviderCards({ content }) {
  const [modalStatus, setModalStatus] = useState(false)

  const CardDetails = ({ fields }) => {
    const [showMore, setShowMore] = useState(false)

    return (
      <div className="flex flex-col gap-2 border-solid border-[0.5px] border-gray-200 pb-4 rounded-sm p-4">
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="flex flex-col gap-1">
            <MediaImageStandard
              content={fields?.logoImage}
              layout="fixed"
              className="w-[180px] h-auto"
            />
            <div className="flex flex-row gap-2 items-center hidden lg:flex">
              <StarRating rating={Number(fields?.overallRating)} size={18} />
              <Typography
                content={'Bills.com rating'}
                className="bodyXs cursor-pointer text-blue-500 underline"
                onClick={() => {
                  setModalStatus(true)
                }}
              />
            </div>
          </div>
          <div className="flex gap-2 lg:gap-4">
            <div className="flex flex-col gap-1">
              <Typography content={'ENROLLMENT FEES'} className="bodyXs text-gray-500" />
              <Typography
                content={fields.provider?.fields?.enrollmentFees}
                className="displayXs lg:displaySm font-bold!"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Typography content={'MONTHLY FEES'} className="bodyXs text-gray-500" />
              <Typography
                content={fields.provider?.fields?.monthlyFees}
                className="displayXs lg:displaySm font-bold!"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Typography content={'COVERAGE'} className="bodyXs text-gray-500" />
              <Typography
                content={fields.provider?.fields?.coverage}
                className="displayXs lg:displaySm font-bold!"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
            <div className="flex flex-col lg:flex-row gap-2 lg:hidden col-1">
              <StarRating rating={Number(fields?.overallRating)} size={18} />
              <Typography
                content={'Bills.com rating'}
                className="bodyXs cursor-pointer text-blue-500 underline"
                onClick={() => {
                  setModalStatus(true)
                }}
              />
            </div>
            <AchieveLink
              href={`/${fields?.slug}`}
              target="_blank"
              className="col-1 flex justify-end"
            >
              <Button variant="contained" className="bg-orange-300 text-white">
                <Typography content={'Check Rates'} className="bodySm" />
              </Button>
            </AchieveLink>
            <div className="col-span-2 lg:col-span-1 w-full">
              <Button
                variant="text"
                className="text-[#3d6feb] flex flex-row gap-2 items-center p-1 hover:bg-transparent w-full"
                onClick={() => setShowMore(!showMore)}
              >
                <Typography content={'SHOW DETAILS'} className="bodySm font-bold!" />
                {showMore ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              </Button>
            </div>
          </div>
        </div>
        {showMore && (
          <ProviderReview
            providerType={fields?.provider?.sys?.contentType?.sys?.id}
            providerData={fields?.provider?.fields}
            description={fields?.description}
          />
        )}
      </div>
    )
  }

  const providerPagesList = useMemo(() => withUuid(content.providerPages), [content.providerPages])

  return (
    <div data-testid="product-provider-cards" className="flex flex-col gap-4 py-4">
      {providerPagesList.map(({ fields, uuid }, index) => (
        <div key={uuid} className="flex flex-col gap-1">
          <Typography content={fields.bestTitle} className="displayXs font-bold!" />
          <CardDetails fields={fields} index={index} />
        </div>
      ))}
      <BillsRatingModal modalStatus={modalStatus} setModalStatus={setModalStatus} />
    </div>
  )
}

export { ProductProviderCards }
